var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { styled, Tab, Tabs } from "@mui/material";
export var StyledTabs = styled(function (props) { return (_jsx(Tabs, __assign({ scrollButtons: true }, props, { TabIndicatorProps: { children: _jsx("span", { className: "MuiTabs-indicatorSpan" }) } }))); })({
    '& .MuiTabs-indicator': {
        display: 'flex',
        justifyContent: 'center',
        backgroundColor: 'transparent',
    },
    '& .MuiTabs-indicatorSpan': {
        maxWidth: 40,
        width: '100%',
        backgroundColor: 'transparent',
    },
    '& .MuiTabs-scrollButtons.Mui-disabled': {
        opacity: 0.3,
    }
});
export var StyledTab = styled(function (props) { return (_jsx(Tab, __assign({ disableRipple: true }, props))); })(function (_a) {
    var _b, _c, _d, _e;
    var theme = _a.theme;
    return (__assign(__assign({}, ((_b = theme === null || theme === void 0 ? void 0 : theme.typography) === null || _b === void 0 ? void 0 : _b.body1)), { textTransform: 'none', marginRight: theme.spacing(1), minHeight: '36px', border: "1px solid ".concat((_c = theme === null || theme === void 0 ? void 0 : theme.palette) === null || _c === void 0 ? void 0 : _c.divider), maxHeight: '36px', height: '36px', borderRadius: '16px', padding: '0 16px', color: (_e = (_d = theme === null || theme === void 0 ? void 0 : theme.palette) === null || _d === void 0 ? void 0 : _d.text) === null || _e === void 0 ? void 0 : _e.primary, '&.Mui-selected': {
        // backgroundColor: theme?.palette?.type === 'light' ? '#000' : "#FFF",
        // color: theme?.palette?.text?.inverse,
        }, '&.Mui-focusVisible': {
        // color: theme?.palette?.text?.inverse,
        } }));
});
